import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import { handleRest } from '../../h2Api'
import {
  CALLBACK_INTAKE_FORM,
  LOAD_INTAKE_FORM,
  SET_ADDITIONAL_JSON
} from '../../actions/profileIntakeActions'

const initialRequestState = {
  ...handleRest(),
  additionalJson: null,
  callbackResults: {}
}
const reducers = (state = initialRequestState, action) => {
  switch (action.type) {
    case LOAD_INTAKE_FORM:
      return {
        ...state,
        ...handleRest(action)
      }
    case SET_ADDITIONAL_JSON:
      return {
        ...state,
        additionalJson: action.additionalJson
      }
    case CALLBACK_INTAKE_FORM:
      if (!action.sectionKey) {
        console.log('Undefined key:', action.sectionKey)

        return state
      }

      return {
        ...state,
        callbackResults: {
          ...state.callbackResults,
          [action.sectionKey]: handleRest(action)
        }
      }
    default:
      return state
  }
}
const intakeReducerRequest = (state = handleRest(), action) => {
  switch (action.type) {
    default:
      return state
  }
}

export const initialFormState = { title: '' }

const intakeReducers = combineReducers({
  form: modelReducer('localOpportunities.profileLoad.form', initialFormState),
  additional: modelReducer('localOpportunities.profileLoad.additional', initialFormState),
  forms: formReducer('localOpportunities.profileLoad', {
    form: initialFormState,
    additional: initialFormState
  }),
  data: reducers,
  formRequest: intakeReducerRequest
})

export default intakeReducers
